import { Units, METERS_PER_UNIT } from 'ol/proj/Units'
import proj4 from 'proj4'
import { get } from 'ol/proj'
import { register } from 'ol/proj/proj4'
import TileLayer from 'ol/layer/Tile'
import { TileWMS } from 'ol/source'
import { ViewType } from '@/interfaces/ViewType'
import VectorLayer from 'ol/layer/Vector'
import OlMap from 'ol/Map'

proj4.defs('EPSG:2154', '+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 ' +
  '+ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs')

register(proj4)

export function getResolutionFromScale (units: Units, scale: number) {
  const dpi = 25.4 / 0.28
  const mpu = METERS_PER_UNIT[units]
  const resolution = scale / (mpu * 39.37 * dpi)
  return resolution
}

export function getScaleFromResolution (units: Units, resolution: number) {
  const dpi = 25.4 / 0.28
  const mpu = METERS_PER_UNIT[units]
  const scale = resolution * (mpu * 39.37 * dpi)
  return scale
}

export const defaultScales = [2500000, 1000000, 500000, 250000, 100000, 50000, 25000, 10000, 5000]
export const defaultScaleClusterExplosion = 100000
export const defaultProjection = get('EPSG:2154')

export const BaseMap: { [key: string]: ViewType } = {
  SCAN: {
    type: 'scan',
    img: require('@/assets/minimap-scan.png'),
    label: 'Scan',
    layer: new TileLayer({
      zIndex: 0,
      source: new TileWMS({
        url: 'http://mapsref.brgm.fr/wxs/refcom-brgm/refign',
        params: {
          LAYERS: 'FONDS_SCAN',
          TRANSPARENT: 'TRUE',
          VERSION: '1.1.1',
          STYLES: '',
          FORMAT: 'image/png',
          SRS: 'EPSG:2154'
        }
      })
    })
  },
  SATELLITE: {
    type: 'satellite',
    img: require('@/assets/minimap-satellite.png'),
    label: 'Satellite',
    layer: new TileLayer({
      zIndex: 0,
      maxResolution: getResolutionFromScale(defaultProjection.getUnits(), 1000000),
      source: new TileWMS({
        url: 'http://mapsref.brgm.fr/wxs/refcom-brgm/refign',
        params: {
          LAYERS: 'ORTHO',
          TRANSPARENT: 'TRUE',
          VERSION: '1.1.1',
          STYLES: '',
          FORMAT: 'image/png',
          SRS: 'EPSG:2154'
        }
      })
    })
  },
  MONDE: {
    fixed: true,
    type: 'monde',
    img: require('@/assets/minimap-monde.png'),
    label: 'Monde',
    layer: new TileLayer({
      zIndex: 0,
      source: new TileWMS({
        url: 'http://mapsref.brgm.fr/wxs/refcom-brgm/refign',
        params: {
          LAYERS: 'MONDE_MOD1_FR',
          TRANSPARENT: 'TRUE',
          VERSION: '1.1.1',
          STYLES: '',
          FORMAT: 'image/png',
          SRS: 'EPSG:2154'
        }
      })
    })
  }
}

export function clearLayer (layer: VectorLayer<any>, force: boolean) {
  const features = layer.getSource()?.getFeatures() || []

  for (const feature of features) {
    if (!force && feature.get('persistant')) continue
    layer.getSource().removeFeature(feature)
  }
}

export class MapSingleton {
  public static map: OlMap
}
